module.exports = __webpack_public_path__ + "static/media/C030.66c61a8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C030.jpg
// module id = 313
// module chunks = 0